// extracted by mini-css-extract-plugin
export default {"appType":"feedback-modal_appType__2XLqE","textArea":"feedback-modal_textArea__2GVDJ"};